import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { Box, Button, TextField, Typography, CircularProgress } from "@mui/material";

const FileUpload = ({ setParsedData }) => {
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [jsonInput, setJsonInput] = useState("");
    const [loading, setLoading] = useState(false);

    // Backend URL based on environment
    const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  (window.location.hostname === 'localhost'
    ? 'http://localhost:4000'
    : 'https://www.plaidreports.com');

    // Handle file drop
    const onDrop = async (acceptedFiles) => {
        setError(null);
        setSuccess(null);
        const file = acceptedFiles[0];

        if (!file) {
            setError("No file selected.");
            return;
        }

        if (file.type !== "application/json") {
            setError("Only JSON files are allowed.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        setLoading(true);
        try {
            const response = await axios.post(`${BACKEND_URL}/api/upload`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            setParsedData(response.data.data);
            setSuccess("File uploaded successfully!");
        } catch (err) {
            console.error("Error uploading file:", err.response?.data || err.message);
            setError(err.response?.data?.error || "An error occurred while uploading the file.");
        } finally {
            setLoading(false);
        }
    };

    // Handle JSON submission
    const handleJsonSubmit = async () => {
        if (!jsonInput.trim()) {
            setError("Please paste valid JSON before submitting.");
            return;
        }

        setError(null);
        setSuccess(null);

        setLoading(true);
        try {
            const parsedJSON = JSON.parse(jsonInput); // Validate JSON
            const response = await axios.post(`${BACKEND_URL}/api/upload-json`, parsedJSON, {
                headers: { "Content-Type": "application/json" },
            });
            setParsedData(response.data.data);
            setSuccess("JSON submitted successfully!");
        } catch (err) {
            console.error("Error processing JSON:", err.message);
            setError("Invalid JSON format. Please check and try again.");
        } finally {
            setLoading(false);
        }
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: { "application/json": [".json"] },
    });

    return (
        <Box>
            {/* Drag-and-drop area */}
            <Box
                {...getRootProps()}
                sx={{
                    border: "2px dashed #ddd",
                    padding: "20px",
                    textAlign: "center",
                    cursor: "pointer",
                    marginBottom: "20px",
                }}
            >
                <input {...getInputProps()} />
                <Typography>Drag & drop a JSON file here, or click to select one</Typography>
            </Box>

            {/* JSON input textarea */}
            <TextField
                multiline
                rows={8}
                fullWidth
                variant="outlined"
                placeholder="Paste your JSON here"
                value={jsonInput}
                onChange={(e) => setJsonInput(e.target.value)}
                sx={{ marginBottom: "10px" }}
            />
            <Button variant="contained" color="primary" onClick={handleJsonSubmit} disabled={loading}>
                Submit JSON
            </Button>

            {/* Error and success messages */}
            {loading && <CircularProgress sx={{ marginTop: "10px" }} />}
            {error && <Typography color="error" sx={{ marginTop: "10px" }}>{error}</Typography>}
            {success && <Typography color="success" sx={{ marginTop: "10px" }}>{success}</Typography>}
        </Box>
    );
};

export default FileUpload;



